import { PagesizeType } from '../../service/pagination/pagesize-type';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Rsvp } from '../../models/rsvp';
import { OnyxEvent } from '../../models/event';
import { TransientTableComponent } from '../transient-table/transient-table.component';
import { TransientReservationStore } from '../../service/transient-reservation-store';
import { TransientSearchComponent } from '../transient-search/transient-search.component';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { TransientReservationSearchParameters } from '../../models/transient-reservation-search-params';
import { TransientReservation } from '../../models/reservation';
import { Page } from '../../../shared/models/page';
import { Constants } from '../../../shared/constants';

@Component({
  selector: 'pioneer-transient-modal',
  templateUrl: './transient-modal.component.html'
})
export class TransientModalComponent implements OnInit {

  @ViewChild(ModalDirective)
  public transientModal: ModalDirective;

  @ViewChild(TransientTableComponent)
  public transientTableComponent: TransientTableComponent;

  @ViewChild(TransientSearchComponent)
  public transientSearchComponent: TransientSearchComponent;

  @Output()
  public closed = new EventEmitter();

  @Input()
  public config = {
    backdrop: 'static',
    keyboard: false
  };

  @Input()
  event: OnyxEvent;

  rsvp: Rsvp;

  searchResults: Page<TransientReservation>;

  pagesizeType = PagesizeType.TRANSIENT_RESERVATIONS;

  constructor(private transientReservationStore: TransientReservationStore,
    private reservationCompareStore: ReservationCompareStore,
    private flashMessagesService: FlashMessagesService) { }

  ngOnInit() {
  }

  public open(rsvp: Rsvp): void {
    if (!this.event) {
      throw new Error('The "event" attribute must be specified to use the TransientModalComponent component');
    }
    if (!rsvp) {
      throw new Error('The "rsvp" parameter must be specified to use the TransientModalComponent component');
    } else {

      this.rsvp = rsvp;

      this.transientSearchComponent.initSearchForm(rsvp);

      const defaultParams = new TransientReservationSearchParameters({
        eventId: this.event.eventId,
        minCheckInDate: this.event.startDate,
        maxCheckOutDate: this.event.endDate,
        firstName: rsvp.firstName,
        lastName: rsvp.lastName
      });

      this.transientSearchComponent.refreshTransientReservations(Constants.SEARCH_DEFAULT_PAGE, defaultParams);
      this.transientModal.show();

    }

  }

  public accept(): void {
    this.transientTableComponent.obtainTransientReservationSelected().subscribe(transientReservation => {
      this.transientReservationStore.linkTransientReservationToEvent(transientReservation.eventReservationId,
        this.event.eventId)
        .subscribe(() => {
          this.flashMessagesService.success('MESSAGES.SUCCESS.TRANSIENT_RESERVATION_LINKED');
          this.reservationCompareStore.refreshCurrentRsvpList(this.event.eventId);
          this.close(true);
        });
    });
  }

  public disableLinkButton(): boolean {
    let disable = false;
    if (this.transientTableComponent && this.transientTableComponent.searchResults) {
        disable = this.transientTableComponent.searchResults.totalElements === 0;
    }
    return disable;
  }

  private close(value: boolean): void {
    this.transientTableComponent.cleanSelected();
    this.closed.emit(value);
    this.transientModal.hide();
  }

  public cancel(): void {
    this.close(false);
  }

  onHasSearched() {

    const obs$ = this.transientReservationStore.searchResults.take(1);

    obs$.subscribe((page: Page<TransientReservation>) => {
      this.searchResults = page;
    });

  }

  onRefreshList(page: number) {
    this.transientSearchComponent.refreshTransientReservations(page);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/transient-modal/transient-modal.component.ts